module.exports = __webpack_public_path__ + "assets/img/JOIN_GATEWAY_PLUGIN.4b71418b.svg";